import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c(VTextField, {
        staticClass: "mx-auto my-2",
        staticStyle: { "max-width": "200px", "font-size": "26px" },
        attrs: {
          outlined: "",
          label: _vm.$vuetify.lang.t("$vuetify.base.documentNumber"),
        },
        on: {
          change: function ($event) {
            return _vm.$emit("update:worksheet", _vm.worksheet)
          },
        },
        model: {
          value: _vm.worksheet.documentNumber,
          callback: function ($$v) {
            _vm.$set(_vm.worksheet, "documentNumber", $$v)
          },
          expression: "worksheet.documentNumber",
        },
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-center mx-2 my-4" },
        [
          _c(
            VBtn,
            {
              attrs: {
                disabled: _vm.worksheet.status == "USED",
                color: "primary",
              },
              on: {
                click: function ($event) {
                  return _vm.updateWorksheet(_vm.worksheet)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.base.update")))]
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }